import { render, staticRenderFns } from "./Dossiers.vue?vue&type=template&id=21a70df9&scoped=true&"
import script from "./Dossiers.vue?vue&type=script&lang=js&"
export * from "./Dossiers.vue?vue&type=script&lang=js&"
import style0 from "./Dossiers.vue?vue&type=style&index=0&id=21a70df9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a70df9",
  null
  
)

export default component.exports